
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/spinner/jst/-spinner';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<svg\n  class=\"spinner\"\n  role=\"img\"\n  title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("spinner")
  },data:data},helper ? helper.call(depth0, "loading_bde52856", "Loading", options) : helperMissing.call(depth0, "t", "loading_bde52856", "Loading", options)))
    + "\"\n  focusable=\"false\"\n>\n  <g role=\"presentation\">\n    <circle class=\"shadow\" cx=\"50%\" cy=\"50%\" r=\"1em\" />\n    <circle class=\"track\" cx=\"50%\" cy=\"50%\" r=\"1em\" />\n    <circle class=\"spin\" cx=\"50%\" cy=\"50%\" r=\"1em\" />\n  </g>\n</svg>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/spinner/jst/_spinner.handlebars', templates['/work/generated/ui/shared/spinner/jst/-spinner']);
    ;
    ;
    export default templates[name];
  